import {ResourceRegistry} from '../registry/ResourceRegistry';
import {DefaultHttpService} from '../http/DefaultHttpService';
import {loggingService} from '../http/DefaultErrorHandler';
import {HttpService, ErrorLoggingService} from '../http/http';
import {DefaultFeatureService} from '../features/DefaultFeatureService';

export class AppContext {
    private _registryApi!: string;
    private _registry!: ResourceRegistry;
    private _extendedRegistry = false;
    private _httpService: HttpService = new DefaultHttpService();
    private _locale: string = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en';
    private _refDate: Date = new Date();
    private _loggingService: ErrorLoggingService = loggingService;
    private _appDB!: any;
    private _featureService = new DefaultFeatureService();

    get featureService(): DefaultFeatureService {
        return this._featureService;
    }

    get appDB(): any {
        return this._appDB;
    }

    set appDB(value: any) {
        this._appDB = value;
    }

    get registryApi(): string {
        return this._registryApi;
    }

    set registryApi(value: string) {
        this._registryApi = value;
    }

    get extendedRegistry(): boolean {
        return this._extendedRegistry;
    }

    set extendedRegistry(value: boolean) {
        this._extendedRegistry = value;
    }

    get loggingService(): ErrorLoggingService {
        return this._loggingService;
    }

    set loggingService(value: ErrorLoggingService) {
        this._loggingService = value;
    }

    set registry(value: ResourceRegistry) {
        this._registry = value;
        this._registry.entries.uploadFile = () => '/upload';
        this._registry.entries.removeFile = () => '/upload/{fileId}';
        this._registry.entries.uploadId = () => '/new-upload';
        this._registry.entries.completeFileUpload = () => '/complete-upload';
    }

    get registry() {
        return this._registry;
    }

    get httpService(): HttpService {
        return this._httpService;
    }

    set httpService(value: HttpService) {
        this._httpService = value;
    }

    get locale(): string {
        return this._locale;
    }

    set locale(value: string) {
        this._locale = value;
    }

    get refDate(): Date {
        return this._refDate;
    }

    set refDate(value: Date) {
        this._refDate = value;
    }
}

const context = new AppContext();

export {context};
